<template>
<section class="course-page-faq section" id="course-faq" aria-labelledby="course-page-faq">

<div class="container px-4 py-5">
  <div class="header text-center">
  <h2 id="course-page-faq">FAQs</h2>

  </div>
         <div class="row justify-content-center">
           <div class="col-md-8">

              <div class="accordion accordion-flush" id="accordionFlushExample">
              <div class="accordion-item">
                <h3 class="accordion-header" id="flush-headingOne">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                    Are online courses worth taking?
                  </button>
                </h3>
                <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">If you’re interested in advancing your education, our online courses are an excellent opportunity to invest in your future.
                      <p class="mt-3">These courses are ideal for students seeking flexibility, convenience, and affordability without sacrificing quality. Our students can work full-time, spend time with family and friends, and still take  a rigorous science or health course from a well-respected and accredited institution.</p>
                  </div>
                </div>
              </div><!--end accordion item-->

              <div class="accordion-item">
                <h3 class="accordion-header" id="flush-headingTwo">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                    What are online college courses like?
                  </button>
                </h3>
                <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">CSU Global Direct online courses are an interactive experience with instructors who are experts in their fields. You will interact with your instructor and peers through engaging discussion board posts and complete a variety of assignments including critical thinking assignments and portfolio projects. Although each course has specific requirements for successful completion, this <a href="https://csuglobal.edu/resources/online-education/sample-coursework" target="_blank">sample class</a> will give you an idea of the feel of the online classroom environment at CSU Global.</div>
                </div>
              </div><!--end accordion item-->

              <div class="accordion-item">
                <h3 class="accordion-header" id="flush-headingThree">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                    Are online courses easier than in-person courses?
                  </button>
                </h3>
                <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">Online courses are different from in-person courses in many ways, presenting both benefits and challenges to the student. In order to succeed in the online environment, students need to take advantage of available technology and support services, connect with their instructors and peers, set aside time to accomplish their goals, and have reasonable expectations. If you are a self-starter who genuinely enjoys the learning experience, we’re confident a path to success exists for you within the CSU Global Direct program.</div>
                </div>
              </div><!--end accordion item-->

              <div class="accordion-item">
                <h3 class="accordion-header" id="flush-headingFour">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                    What are the advantages of studying online?
                  </button>
                </h3>
                <div id="flush-collapseFour" class="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">There are many benefits to completing your prerequisite courses online, the most obvious is flexibility. With no fixed class times or locations, you're free to pursue your education without putting life on hold. Additionally, rolling start dates provide you the opportunity to start classes when you’re ready, putting you on the fast track toward your academic and career goals. Also, CSU Global Direct is affordable. Nationally, college tuition increases 8% on average every year, but CSU Global has not increased tuition rates in over 10 years.
                    <p class="mt-3">Additionally, we don't charge any student fees or out-of-state premiums at CSU Global. Students aren't burdened with the cost of a ground campus but do have access to similar (and sometimes expanded) student resources.</p>
                  </div>
                </div>
              </div><!--end accordion item-->

              <div class="accordion-item">
                <h3 class="accordion-header" id="flush-headingFive">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                    Are online courses respected by medical programs?
                  </button>
                </h3>
                <div id="flush-collapseFive" class="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">
                    CSU Global has earned regional accreditation by the Higher Learning Commission (HLC). Regional accreditation is highly regarded and respected by other universities and colleges, medical programs, and employers because it is a comprehensive, peer-reviewed process that ensures a consistent standard of quality for higher education institutions. 
                  </div>
                </div>
              </div><!--end accordion item-->


              <div class="accordion-item">
                <h3 class="accordion-header" id="flush-headingSix">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix">
                    Will online courses help me get into my preferred medical program?
                  </button>
                </h3>
                <div id="flush-collapseSix" class="accordion-collapse collapse" aria-labelledby="flush-headingSix" data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">
                    CSU Global Direct’s online courses are designed to satisfy prerequisites for various academic programs including medical, dental, nursing, and PA school. Before beginning your studies, we recommend that you contact the enrollment office of your preferred institution’s program to ensure that all credits obtained through CSU Global Direct satisfy their transfer and admissions requirements. 
                    <p class="mt-3">Additionally, CSU Global Direct courses provide you with a valuable opportunity to improve your GPA and enhance your health sciences program application.</p>
                  </div>
                </div>
              </div><!--end accordion item-->

              <div class="accordion-item">
                <h3 class="accordion-header" id="flush-headingSeven">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSeven" aria-expanded="false" aria-controls="flush-collapseSeven">
                    Are CSU Global Direct's online courses accredited?
                  </button>
                </h3>
                <div id="flush-collapseSeven" class="accordion-collapse collapse" aria-labelledby="flush-headingSeven" data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">
                    Yes, CSU Global is proud to be an <a href="https://csuglobal.edu/about/our-university/accreditation/2020-comprehensive-evaluation" target="_blank">accredited university through the Higher Learning Commission</a> (HLC). Accreditation is highly regarded around the world because it is a comprehensive, peer-reviewed process that ensures a consistent standard of quality for higher education institutions. Accreditation standards require that up to one-third of a degree program’s curriculum includes general education courses in social, natural, and physical sciences, English, math, humanities, and art. Colleges and universities that are accredited usually only accept undergraduate transfer credits or transfer degrees from other accredited institutions.</div>
                </div>
              </div><!--end accordion item-->

              <div class="accordion-item">
                <h3 class="accordion-header" id="flush-headingEight">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseEight" aria-expanded="false" aria-controls="flush-collapseEight">
                    How can I verify that CSU Global Direct's course credits will transfer to my school of choice?
                  </button>
                </h3>
                <div id="flush-collapseEight" class="accordion-collapse collapse" aria-labelledby="flush-headingEight" data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">
                    CSU Global Direct’s online courses are designed to satisfy prerequisites for various programs. Before beginning your studies, we recommend that you contact the enrollment office of your preferred institution’s program to ensure that all credits obtained through CSU Global satisfy their transfer and admissions requirements.
                  </div>
                </div>
              </div><!--end accordion item-->

              <div class="accordion-item">
                <h3 class="accordion-header" id="flush-headingNine">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseNine" aria-expanded="false" aria-controls="flush-collapseNine">
                    Do online courses impact my GPA?
                  </button>
                </h3>
                <div id="flush-collapseNine" class="accordion-collapse collapse" aria-labelledby="flush-headingNine" data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">
                    Yes, online courses impact your GPA. Performing well in your CSU Global Direct courses is likely to increase your GPA in science, and can help enhance your application for the graduate program you intend to apply to. 
                  </div>
                </div>
              </div><!--end accordion item-->

              <div class="accordion-item">
                <h3 class="accordion-header" id="flush-headingTen">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTen" aria-expanded="false" aria-controls="flush-collapseTen">
                    How do I get started?
                  </button>
                </h3>
                <div id="flush-collapseTen" class="accordion-collapse collapse" aria-labelledby="flush-headingTen" data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">
                    Ready to take the next step? <router-link to="/get-started">Click here to enroll in CSU Global Direct courses today via our self-serve portal</router-link>.
                    <p class="mt-3">If you have any questions along the way, please don’t hesitate to reach out to an enrollment counselor via phone at <a href="tel:1-800-672-0624">1-800-672-0624</a> or email <a href="mailto:global.direct@csuglobal.edu">global.direct@csuglobal.edu</a>. </p>
                  </div>
                </div>
              </div><!--end accordion item-->

            </div><!--end accordion-->










           </div><!--end accordion col-->
         </div><!--end row-->
        </div><!--end container-->
    </section><!--end section-->

</template>

<script>
export default {
  name: 'CoursePageFAQ',
  props: {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.accordion-button:not(.collapsed) {
  color:#fff;
  background-color:#18c9b9;
}

.accordion-body {
  margin-left:2rem;
}

.accordion-button:not(.collapsed)::after {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='white'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
}

.accordion-button:focus {
  box-shadow:none;
}

</style>
